import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiPayloadCreator } from "util/api";
import { selectAuthToken } from "redux/features/auth";
import { profileSlice } from "redux/features/profile";

const apiCall = createAsyncThunk(
  "account/changePassword",
  apiPayloadCreator(
    "/account/change-password",
    "post",
    (success, arg, thunkAPI) => {
      const { data } = arg;
      const { person_id, disable_password } = data;
      thunkAPI.dispatch(
        profileSlice.actions.updatePerson({
          public_id: person_id,
          no_password: !!disable_password,
        })
      );
    }
  )
);

export const changePasswordSlice = createSlice({
  name: "changePassword",
  initialState: {
    sendingFor: null,
    sent: false,
    failure: null,
  },
  reducers: {
    clear: (state, action) => {
      state.sendingFor = null;
      state.sent = false;
      state.failure = null;
    },
  },

  extraReducers: {
    [apiCall.pending]: (state, action) => {
      const { person_id } = action.meta.arg.data;
      state.sendingFor = person_id;
      state.sent = false;
      state.failure = null;
    },
    [apiCall.fulfilled]: (state, action) => {
      const { person_id } = action.meta.arg.data;
      if (state.sendingFor === person_id) {
        state.sent = true;
        state.failure = null;
      }
    },
    [apiCall.rejected]: (state, action) => {
      const { person_id } = action.meta.arg.data;
      if (state.sendingFor === person_id) {
        state.sent = true;
        state.failure = action.payload;
      }
    },
  },
});

changePasswordSlice.selector = (store) => store.changePassword;

changePasswordSlice.asyncActions = {
  send: (data) => (dispatch) => {
    return dispatch(apiCall({ selectAuthToken, data }));
  },
};

export default changePasswordSlice.reducer;
